import { isLevelCleared, isLevelUnlocked } from "../progress/campaign";
import { LEVELS, LEVEL_ORDER } from "../levels";

/**
 * Lista de níveis por cima do splash original (partículas + palavra).
 * Não substitui o ecrã inicial.
 */
export class GamePanel {
  private readonly root: HTMLDivElement;
  private readonly list: HTMLUListElement;

  constructor(
    host: HTMLElement,
    private readonly onPick: (levelId: string) => void,
  ) {
    this.root = document.createElement("div");
    this.root.className = "onirya-campaign";
    this.root.setAttribute("aria-hidden", "true");

    this.list = document.createElement("ul");
    this.list.className = "onirya-campaign-list";

    this.root.addEventListener("pointerdown", (e) => {
      if (e.target === this.root) {
        e.preventDefault();
        this.hide();
      }
    });

    this.root.append(this.list);
    host.appendChild(this.root);
  }

  bringToFront(host: HTMLElement): void {
    host.appendChild(this.root);
  }

  get open(): boolean {
    return this.root.classList.contains("is-active");
  }

  show(): void {
    this.render();
    this.root.classList.add("is-active");
    this.root.setAttribute("aria-hidden", "false");
  }

  hide(): void {
    this.root.classList.remove("is-active");
    this.root.setAttribute("aria-hidden", "true");
  }

  private render(): void {
    this.list.replaceChildren();
    for (const id of LEVEL_ORDER) {
      const level = LEVELS[id];
      if (!level) continue;
      const li = document.createElement("li");
      const unlocked = isLevelUnlocked(id);
      const cleared = isLevelCleared(id);
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "onirya-wake-play is-visible onirya-campaign-level";
      btn.textContent = level.title;
      btn.disabled = !unlocked;
      if (cleared) btn.classList.add("is-cleared");
      if (!unlocked) btn.classList.add("is-locked");
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!unlocked) return;
        this.onPick(id);
      });
      li.append(btn);
      this.list.appendChild(li);
    }
  }
}
